import { j as p } from "./index.es33.js";
import { useRef as s } from "react";
import { useModalFocusLock as t } from "./index.es498.js";
import { usePageScrollLock as m } from "./index.es499.js";
var i = function i(_ref) {
  var r = _ref.children,
    e = _ref.modalRef;
  var o = s(null);
  return m(o), t(e), p.jsx("div", {
    ref: o,
    children: r
  });
};
export { i as ModalWrapper };